import React, { useState } from 'react';
import { db } from '../firebase';
import { collection, addDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

const ContactUs = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.subject || !formData.message) {
      setError('All fields are required.');
      return;
    }
    setError('');
    setSuccess('');
    try {
      await addDoc(collection(db, 'contactMessages'), {
        ...formData,
        createdAt: new Date().toISOString(),
      });
      setSuccess('Message sent successfully!');
      setFormData({ name: '', email: '', subject: '', message: '' });
      setTimeout(() => navigate('/'), 2000);
    } catch (err) {
      setError('Failed to send message: ' + err.message);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 text-black flex flex-col items-center justify-between font-['Noto Sans']">
      <Header />
      <div className="p-6 max-w-3xl w-full mx-auto">
        {/* Contact Us Heading */}
        <div className="text-center mb-8">
          <h2 className="text-4xl font-extrabold text-gray-700">Get in Touch with Us</h2>
          <p className="text-lg text-gray-500 mt-2">
            Have questions or need assistance? Fill out the form below, and our team will get back to you as soon as possible.
          </p>
        </div>

        {/* Success/Error Messages */}
        {success && <div className="mb-4 p-3 bg-green-100 text-green-700 rounded-lg text-center">{success}</div>}
        {error && <div className="mb-4 p-3 bg-red-100 text-red-700 rounded-lg text-center">{error}</div>}

        {/* Contact Form */}
        <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow-lg p-6 border border-gray-300">
          <div className="space-y-4">
            <div>
              <label className="block text-gray-700 font-medium mb-1">Name *</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full p-3 border rounded-lg border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>
            <div>
              <label className="block text-gray-700 font-medium mb-1">Email *</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="w-full p-3 border rounded-lg border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>
            <div>
              <label className="block text-gray-700 font-medium mb-1">Subject *</label>
              <input
                type="text"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                className="w-full p-3 border rounded-lg border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>
            <div>
              <label className="block text-gray-700 font-medium mb-1">Message *</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                className="w-full p-3 border rounded-lg border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                rows="4"
                required
              ></textarea>
            </div>
          </div>
          {/* Submit Button */}
          <div className="flex justify-end mt-6">
            <button
              type="submit"
              className="px-6 py-2 mt-6 bg-green-600 text-white px-6 py-3 rounded-full hover:bg-green-700 transition-transform duration-300 font-semibold shadow-2xl"
            >
              Send Message
            </button>
          </div>
        </form>
      </div>
      <Footer />
    </div>
  );
};

export default ContactUs;
